import { array } from 'fp-ts';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { RestrictionParameters, RestrictionResult } from '@mews-commander/data-access';
import { createFetchAction } from '@mews-commander/utils';
import {
    deleteRestrictions as deleteRestrictionsDucks,
    setRateGroups,
    setRates,
    setResourceCategories,
    setCategories,
    setProfiles,
    updateRestrictionsState,
} from '@mews-commander/legacy-entities/src/ducks';
import { prefix } from '../module';

const RESTRICTIONS_FETCH = prefix('RESTRICTIONS_FETCH');
const RESTRICTIONS_DELETE = prefix('RESTRICTIONS_DELETE');

const fetch =
    ({ serviceId, ...other }: RestrictionParameters): CommanderThunkAction =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.restrictions
            .getAll({ serviceId, ...other })
            .then(({ rateGroups, rates, restrictions, resourceCategories, profiles }: RestrictionResult) => {
                if (rateGroups != null) {
                    dispatch(setRateGroups(rateGroups, serviceId));
                }
                if (rates != null) {
                    dispatch(setRates(rates, serviceId));
                }
                if (resourceCategories != null) {
                    dispatch(setResourceCategories(resourceCategories, serviceId));
                    dispatch(setCategories(resourceCategories, serviceId));
                }
                if (profiles && array.isNonEmpty(profiles)) {
                    dispatch(setProfiles(profiles));
                }
                if (restrictions) {
                    dispatch(updateRestrictionsState(restrictions, serviceId));
                }
            });

        return dispatch(createFetchAction(RESTRICTIONS_FETCH, promise));
    };

export const fetchRestrictions = ({
    startUtc,
    endUtc,
    restrictionIds,
    serviceId,
    extent: { rateGroups, rates, resourceCategories, profiles, resourceCategoryTypes } = {},
}: $TSFixMe) =>
    fetch({
        startUtc,
        endUtc,
        restrictionIds,
        serviceId,
        extent: { rateGroups, rates, resourceCategories, profiles, resourceCategoryTypes },
    });

export const deleteRestrictions =
    ({
        serviceId,
        restrictionIds,
    }: {
        serviceId: string;
        restrictionIds: string[];
    }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.restrictions.delete({ serviceId, restrictionIds }).then(() => {
            dispatch(deleteRestrictionsDucks(restrictionIds, serviceId));
        });

        return dispatch(createFetchAction(RESTRICTIONS_DELETE, promise, { scope: serviceId }));
    };
